export const TABLE_TITLES = [
  "Vencimento",
  "Endereço",
  "Valor Total",
  "Status",
  "Boleto",
];